import { isNeverbounceEnabled } from "@utils/configuration/aem";

import FeatureToggles, {
    FeatureToggleKeys,
} from "@services/featureToggles.services";

type CacheItem = {
    email: string;
    valid: boolean;
};

const EMAIL_CACHE: Array<CacheItem> = [];

const validateEmail = async (email: string): Promise<boolean> => {
    return new Promise((resolve, reject) => {
        if (window._nb) {
            window._nb.api.getValidatePublic(
                email,
                (responseData: any) => {
                    const isInvalid =
                        responseData.response.result === "invalid";
                    EMAIL_CACHE.push({ email, valid: !isInvalid });
                    resolve(!isInvalid);
                },
                reject,
            );
        } else {
            // When Neverbounce could not be loaded
            resolve(true);
        }
    });
};

const checkCache = async (email: string): Promise<CacheItem | null> => {
    return new Promise(resolve => {
        const result = EMAIL_CACHE.find(
            i => i.email.toLowerCase() === email.toLowerCase(),
        );

        if (result) {
            resolve(result);
        } else {
            resolve(null);
        }
    });
};

const validateEmailAddress = async (email: string): Promise<boolean> => {
    const hasFeature = FeatureToggles.hasFeature(FeatureToggleKeys.NEVERBOUNCE);

    // if no feature is set, the global one is determing
    if (!hasFeature && !isNeverbounceEnabled()) {
        return true;
    }

    // in any other case the localStorage featureToggle overrules
    // hasFeature check included because isEnabled also returns false
    // when no feature is found
    if (
        hasFeature &&
        !FeatureToggles.isEnabled(FeatureToggleKeys.NEVERBOUNCE)
    ) {
        return true;
    }

    const exists = await checkCache(email);
    if (exists) {
        return exists.valid;
    }

    return await validateEmail(email);
};

export { validateEmailAddress };
